import { useIntl } from '@doxyme/locale';
import {
  ButtonWithDropdown,
  ContextMenu,
  MenuCell,
  SubscriptionBadge,
} from '@doxyme/ui/components/foundations';
import { useTheme } from '@doxyme/ui/theme';
import { useViewport } from '@doxyme/ui/hooks';
import { Icon } from '@doxyme/icons';
import { useRef, type JSX } from 'react';

export type InviteViaProps = {
  isPaidUser: boolean;
  isMenuOpen: boolean;
  toggleMenu: (isOpen: boolean) => void;
  openInviteViaEmail: () => void;
  openInviteViaTextMessage: () => void;
};

export const InviteVia = ({
  isPaidUser,
  isMenuOpen,
  toggleMenu,
  openInviteViaEmail,
  openInviteViaTextMessage,
}: InviteViaProps): JSX.Element => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const buttonRef = useRef<HTMLButtonElement>(null);
  const { isSmallViewport } = useViewport();

  return (
    <>
      <ButtonWithDropdown
        id='invite-via-button'
        type='secondary'
        innerRef={buttonRef}
        dropdownOpen={isMenuOpen}
        onClick={() => toggleMenu(!isMenuOpen)}
        fullWidth={isSmallViewport}
      >
        {formatMessage({ id: 'inviteViaButton' })}
      </ButtonWithDropdown>

      <ContextMenu
        isOpen={isMenuOpen}
        onClose={() => toggleMenu(false)}
        openerElement={buttonRef.current}
        anchorElement={buttonRef.current}
        placement='bottom-end'
        offset={Number.parseInt(theme.spacing(2))}
        preventScrollOnFocus={isSmallViewport}
      >
        <MenuCell
          icon={Icon.TextMessage}
          label={formatMessage({ id: 'inviteVia.textMessage' })}
          mark={
            isPaidUser ? (
              ''
            ) : (
              <SubscriptionBadge
                content={formatMessage({ id: 'pro' })}
                active
              />
            )
          }
          onClick={openInviteViaTextMessage}
          triggerElementId='invite-via-button'
        />
        <MenuCell
          icon={Icon.Mail}
          label={formatMessage({ id: 'inviteVia.email' })}
          onClick={openInviteViaEmail}
          triggerElementId='invite-via-button'
        />
      </ContextMenu>
    </>
  );
};
